import {
  DealerInformation,
  OrganizationInformation
} from "@common-core/coat-operational-hierarchy-appsync-model";
import {toOrganizationAddress} from "./toOrganizationAddress";

export const toOrganizationInformation = (
  information?: DealerInformation
): OrganizationInformation => {
  return {
    dbaName: information?.dbaName || "",
    legalName: information?.legalName,
    status: information?.status,
    telecomNumbers: information?.primaryPhone
      ?.split(",")
      .map(number => number.trim()),
    address: toOrganizationAddress(information?.address)
  };
};
